import { BrowserWindowIllustration } from "./browser-window-illustration";
import { Outline } from "./illustration";

interface Props {
  className?: string;
}

// A browser window reloading.
export function UpdateIllustration({ className }: Props) {
  return (
    <BrowserWindowIllustration className={className}>
      <Outline d="M37 50A19 19 0 0 1 56 31A20.58 20.58 0 0 1 70.23 36.78L75 41.56M75 31V41.56H64.44M75 50A19 19 0 0 1 56 69A20.58 20.58 0 0 1 41.77 63.22L37 58.44M47.56 58.44H37V69" />
    </BrowserWindowIllustration>
  );
}
